import {Injectable} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {AutofillConfig} from './autofill.config';
import {Subject} from 'rxjs';
import {FieldTypeEnum} from '../dynamic-field/field-type.enum';
import {DynamicFormService} from '../dynamic-form/dynamic-form.service';
import {FieldConfigWrapper} from '../dynamic-field/field-config-wrapper';

@Injectable({providedIn: 'root'})
export class DynamicFormAutofillService {

    private autoFillSelectSubject = new Subject();
    public autoFillSelect = this.autoFillSelectSubject.asObservable();
    private formValue: Map<string, { [key: string]: any }> = new Map();
    private formConfiguration: Map<string, AutofillConfig> = new Map();

    public getConfiguration(formName: string): AutofillConfig {
        return this.formConfiguration.get(formName);
    }

    public setFormConfiguration(formName, config) {

        if (!this.formConfiguration.has(formName)) {
            this.formConfiguration.set(formName, {fields: [config]});

            return;
        }
        if (this.formConfiguration.has(formName)) {

            const formConfig = this.formConfiguration.get(formName).fields;
            const valueToFind = formConfig.find(value => value.name === config.name);

            if (valueToFind) {

                this.formConfiguration.set(formName, {fields: formConfig.filter(value => value.name !== config.name)});

                return;
            }

            this.formConfiguration.set(formName, {fields: [config].concat(formConfig)});
        }

    }

    public getAutofillValues(formName: string): { [key: string]: any } {
        return this.formValue.get(formName);
    }

    public saveAutofillValues(formName: string, formGroup: UntypedFormGroup) {
        const autofillConfig = this.getConfiguration(formName);
        if (!autofillConfig) {

            return;
        }

        const formValue = {};
        autofillConfig.fields.forEach(config => {
            formValue[config.name] = formGroup.get(config.name).value;
        });

        this.formValue.set(formName, formValue);
    }

    public fillForm(formName: string, formGroup: UntypedFormGroup) {
        if (this.formValue.get(formName)) {
            formGroup.patchValue(this.formValue.get(formName));
        }

    }

    public async autoFilterSelectValue(dynamicFromService: DynamicFormService): Promise<void> {
        await new Promise(resolve => setTimeout(resolve, 500));

        const formGroup = dynamicFromService?.formGroup;
        if (!formGroup) {
            return
        }

        dynamicFromService.fieldWrappers.forEach((wrapper: FieldConfigWrapper<any>) => {
            if (
                wrapper.config?.required &&
                !wrapper.config.value &&
                (wrapper.config.type === FieldTypeEnum.filterSelect
                    || wrapper.config.type === FieldTypeEnum.select)
                && wrapper.source?.length === 1
            ) {
                const field = formGroup.get(wrapper.config.name);
                field?.setValue((wrapper.config).source[0]?.id);
            }
        })


    }

    openAutofillSelect(formName) {
        this.autoFillSelectSubject.next(formName);
    }
}
